import paths from './paths';
import tiles from './tiles';

export const PATHS = paths;
export const TILES = tiles;
